import React from 'react';

import styles from './BottomSheetCustomContents.module.scss';

const BottomSheetCustomContents: React.FC = ({ children }) => {
  return <div className={styles.customContents}>{children}</div>;
};

export default BottomSheetCustomContents;
